import ABCyaLib from '@abcya/abcya_lib';
import { enTitleLetters, esTitleLetters } from './scenes/intro/TitlePathPoints';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    letterTray:{
      letterArray: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"],
      letterPadding: 270,
      letterScale: .2,
      accentAdj: 0,
      startY: -310,
    },
    intro:{
      maskBGY: -120,
      letterArr: enTitleLetters,
      padding: 5,
      letterY: 35,
    },
    spanishDefaults:{
      letterArray: ["a", "á", "b", "c", "d", "e", "é", "f", "g", "h", "i", "í", "j", "k", "l", "m", "n", "ñ", "o", "ó", "p", "q", "r", "s", "t", "u", "ú", "ü", "v", "w", "x", "y", "z"],
      letterPadding: 285,
      letterScale: .15,
      accentAdj: -5,
      startY: -325,
    }
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.letterTray.letterArray = ["a", "á", "b", "c", "d", "e", "é", "f", "g", "h", "i", "í", "j", "k", "l", "m", "n", "ñ", "o", "ó", "p", "q", "r", "s", "t", "u", "ú", "ü", "v", "w", "x", "y", "z"];
      config.letterTray.letterPadding = 285;
      config.letterTray.letterScale = .15;
      config.letterTray.accentAdj = -5;
      config.letterTray.startY = -325;
      config.intro.maskBGY = -100;
      config.intro.letterArr = esTitleLetters;
      config.intro.padding = -2;
      config.intro.letterY = 0;
      break;
  }

  return config;
}